import { render, staticRenderFns } from "./water-sports-in-north-goa.vue?vue&type=template&id=4f6d7acc&scoped=true"
import script from "./water-sports-in-north-goa.vue?vue&type=script&lang=js"
export * from "./water-sports-in-north-goa.vue?vue&type=script&lang=js"
import style0 from "./water-sports-in-north-goa.vue?vue&type=style&index=0&id=4f6d7acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d7acc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
